import { camelToSnakeCase } from '@/utils/language-service';

/**
 * Automatically imports all the modules and exports as a single module object
 */
const requireStoreModules = require.context('.', false, /\.store\.js$/);

// remove the store.js extension and capitalize
const getModuleNameFromFileName = (moduleFileName) => moduleFileName.replace(/(\.\/|\.store\.js)/g, '');

const moduleFileNames = requireStoreModules.keys();

/**
 * first we build MODULES_NAMES object, used by in const.js file of every module
 * example:
 * {
 * 	SELECTED_WORKFLOW: 'selectedWorkflow',
 * 	SELECTED_PROJECT: 'selectedProject',
 * 	ALERTS: 'alerts',
 * 	...
 * }
 */
export const MODULES_NAMES = moduleFileNames.reduce((MODULES_NAMES, moduleFileName) => {
	const moduleName = getModuleNameFromFileName(moduleFileName);
	return { ...MODULES_NAMES, [camelToSnakeCase(moduleName).toUpperCase()]: moduleName };
}, {});

/**
 * then, we require each module
 */
const modules = moduleFileNames.reduce((modules, moduleFileName) => {
	const moduleName = getModuleNameFromFileName(moduleFileName);
	return { ...modules, [moduleName]: requireStoreModules(moduleFileName).default || requireStoreModules(moduleFileName) };
}, {});

export default modules;
